export default "__VITE_ASSET__UlkYahYK__"